import { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import { LocalStorage } from '../../services/localStorage/LocalStorage.services'

import Modal from '../../components/Modal/Modal'

import getAreaById from '../../services/arees/getAreaById'
import postArea from '../../services/arees/postArea'
import putArea from '../../services/arees/putArea'

import styles from './NewArea.module.css'

const NewArea = () => {

    let navigate = useNavigate()

    const { id } = useParams()
    const [ newArea, setNewArea ] = useState({})
    const [ active, setActive ] = useState(true)
    const [ error, setError ] = useState("")
    const [ disable, setDisable ] = useState(true)

    useEffect(() => {
        if (id !== undefined) {
            getAreaById(id)
            .then(area => {
                setNewArea(area)
                setActive(area.areaActive)
            })
        }
    },[id])

    const handleSubmit = (event) => {
        event.preventDefault()
        const form = event.target
        const formData = new FormData(form)
        formData.append('areaActive', event.target.areaActive.checked)
        formData.append('areaCompanyId', LocalStorage.getItem("professionalCompany"))
        formData.append('areaServeiId', LocalStorage.getItem("professionalServei"))
        const formJson = Object.fromEntries(formData.entries())
        if (id !== undefined) {
            putArea(formJson, id) 
            .then(newArea => {
                setNewArea(newArea)
            })
        } else {
            postArea(formJson) 
            .then(newArea => {
                setNewArea(newArea)
            })
        }
        setDisable(false)
        setTimeout(() => {
            setDisable(true)
            navigate("/projectes", { replace: true })
        },3000)
    }

    const handleChange = (event) => {
        if (event.target.id === "areaActive") {
            setActive(event.target.checked)
        } else {
            setNewArea(event.target.value)
        }
    }

    return (
        <div className={styles.container}>
            <h2>{id ? "Editar area" : "Alta nova area"}</h2>
            <div className={disable && styles.disable}>
                <Modal error={error} id={id} text={id ? "Area modificada correctament" : "Area creada correctament"}></Modal>
            </div>
            <form onSubmit={handleSubmit}>
                <label for="areaName">Nom</label>
                <input type='text' onChange={handleChange} name="areaName" value={newArea.areaName}></input>
                <label for="areaActive">Actiu</label>
                <input type='checkbox' onChange={handleChange} name="areaActive" id="areaActive" checked={active} className={styles.checking} />
                <div className={styles.btn_container}>
                    <button className={styles.btn_add} type='submit'>{id ? <i className="fa-regular fa-floppy-disk"></i> : <i className="fa-solid fa-circle-plus"></i>}{id ? "Guardar" : "Crear"}</button>
                </div>
            </form>
        </div>
    )
}

export default NewArea